<div class="h-full flex flex-col">
    <div class="w-full h-full flex flex-col justify-around">
        <div class="gradient-container relative flex flex-col items-center justify-around gap-2">
            <div class="gradient-background"></div>
            <div class="flex p-[0.15rem] rounded-xl border border-arena-orange-100 bg-arena-orange-50/1 relative z-10">
                <div class="">
                    <div class="flex p-4 border bg-white rounded-xl">
                        <div class="flex items-center justify-center gap-3">
                            @if (integration.imgSvgPath) {
                            <div [innerHTML]="integration.imgSvgPath | sanitizeHtml"
                                class="w-8 h-8 [&>svg]:w-8 [&>svg]:h-8"></div>
                            } @else if (integration.imgPath) {
                            <img width="32" height="32" [src]="(integration.imgPath || '') | assetUrl"
                                [alt]="integration.name" class="object-contain" />
                            }
                            <span class="text-lg font-medium">{{ integration.name }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex flex-col items-center space-y-1.5 relative z-10">
                @for(dot of dots; track $index){
                <div class="h-1 w-1 rounded-full bg-orange-400/80"></div>
                }
            </div>
            <div class="flex p-[0.15rem] rounded-xl border border-arena-orange-100 bg-arena-orange-50/1 relative z-10">
                <div class="">
                    <div class="flex p-4 border bg-white rounded-xl">
                        <img width="100" [src]="'images/logos/innDocAI-themed.png' | assetUrl" alt="InnDoc logo">
                    </div>
                </div>
            </div>
        </div>

        @if (integration.key === INTEGRATION_TYPE.DATABASE_INTEGRATION_SETTINGS) {
        <app-database-connection [integration]="integration" (close)="onClose($event)"></app-database-connection>
        } @else {

        @if(integration.connected){
        <div class="flex flex-col items-center gap-2">
            <div class="px-2 py-1 bg-green-100 rounded-lg">
                <span class="text-green-700 font-medium">Connected</span>
            </div>

        </div>
        }

        <div class="flex flex-col gap-3 px-4">
            @if (!integration.connected) {
            <div class="flex justify-center">
                <app-button label="Connect" [size]="'lg'" [loading]="isConnecting" severity="primary"
                    styleClass="w-full max-w-md" (clicked)="onConnect()" />
            </div>

            <div class="flex gap-2 text-sm text-gray-600 text-center items-center justify-center">
                <i class="pi pi-info-circle"></i>
                <span>Clicking "Connect" will establish the integration</span>
            </div>
            } @else {
            <div class="flex gap-3 justify-center items-center">
                <app-button label="Disconnect" severity="contrast" variant="outlined" [loading]="isDisconnecting"
                    styleClass="flex-1 max-w-md" (clicked)="onDisconnect()" />
            </div>
            <div class="flex gap-2 text-sm text-gray-600 text-center items-center justify-center">
                <i class="pi pi-info-circle"></i>
                <span>Clicking "Disconnect" will disconnect the integration</span>
            </div>
            }
        </div>
        }
    </div>
</div>